"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_query_1 = require("react-query");
const ObjectivesClient_1 = require("client/ObjectivesClient");
const UserContext_1 = require("context/UserContext");
const HelperUtils_1 = require("utils/HelperUtils");
const FormattedNumber_1 = __importDefault(require("components/design-system/FormattedNumber"));
const Shimmer_1 = __importDefault(require("components/design-system/shimmer/Shimmer"));
const SVGIcon_1 = __importDefault(require("components/shared/SVGIcon"));
const TooltipContainer_1 = __importDefault(require("components/shared/Tooltips/TooltipContainer"));
const CreateObjectivesWarningHelpers_1 = require("pages/create-objective-warning/CreateObjectivesWarningHelpers");
const TopParent = ({ objectiveId, objectiveConfigs, page, useFixedWidth, useCompactLayout }) => {
    const [totalObjectives, setTotalObjectives] = (0, react_1.useState)(0);
    const label = page === 'teamGoals' ? 'Sub Goal' : 'Top Parent';
    const { config } = (0, UserContext_1.useUser)();
    const { maxObjectivesOn, minObjectivesOn } = config.objectivesConfig;
    const { minSubgoal: minNumberOfObjectives, maxSubgoal: maxNumberOfObjectives } = objectiveConfigs;
    const { message } = (0, CreateObjectivesWarningHelpers_1._conditionMinMaxObjectiveTooltipMessageHelper)({
        maxObjectivesOn,
        minObjectivesOn,
        maxNumberOfObjectives,
        minNumberOfObjectives,
        totalObjectives
    });
    const { conditionConfigMinMaxNoValidate } = (0, CreateObjectivesWarningHelpers_1._conditionMinMaxObjectivesHelper)({
        maxObjectivesOn,
        minObjectivesOn,
        maxNumberOfObjectives,
        minNumberOfObjectives,
        totalObjectives
    });
    const fetchChildrenCount = () => {
        const query = {
            metadata: 'count'
        };
        return (0, ObjectivesClient_1.getObjectiveChildren)(objectiveId, query);
    };
    const { isFetching } = (0, react_query_1.useQuery)(['overallProgress', 'topParent', objectiveId], fetchChildrenCount, {
        onSuccess: (data) => {
            var _a, _b, _c;
            if ((_a = data === null || data === void 0 ? void 0 : data.metadata) === null || _a === void 0 ? void 0 : _a.metadata) {
                setTotalObjectives((_c = (_b = data === null || data === void 0 ? void 0 : data.metadata) === null || _b === void 0 ? void 0 : _b.metadata) === null || _c === void 0 ? void 0 : _c.count);
            }
        }
    });
    return isFetching ? (react_1.default.createElement(Shimmer_1.default, { width: "168px", height: "16px" })) : (react_1.default.createElement("div", { className: `flex ${useFixedWidth ? 'w-[168px]' : 'w-auto'} ${useCompactLayout ? 'flex-col gap-[8px]' : 'flex-row items-center'}` },
        react_1.default.createElement("div", { className: useCompactLayout ? 'flex' : '' },
            react_1.default.createElement(TooltipContainer_1.default, { classContainer: `flex flex-row items-center ${message ? 'cursor-pointer' : ''}`, show: message, text: message, dataCy: "overall-top-parent" },
                !conditionConfigMinMaxNoValidate && (react_1.default.createElement(SVGIcon_1.default, { customClass: "mr-[4px]", iconName: "icon-warning", fillColor: "var(--y-500)", size: 16 })),
                react_1.default.createElement(FormattedNumber_1.default, { number: totalObjectives, minDecimalLength: 0, customClass: `${conditionConfigMinMaxNoValidate ? 'text-n-900' : 'text-r-600'} typography-h400 `, dataCy: "overall-objective-total" }),
                (maxObjectivesOn || minObjectivesOn) && (react_1.default.createElement(react_1.default.Fragment, null,
                    react_1.default.createElement("p", { className: "typography-h400 text-n-900" },
                        `\u00A0/`,
                        `\u00A0`),
                    react_1.default.createElement(FormattedNumber_1.default, { number: maxObjectivesOn
                            ? maxNumberOfObjectives
                            : minNumberOfObjectives, minDecimalLength: 0, customClass: "typography-h400 text-n-900" }))))),
        react_1.default.createElement("p", { className: `${useCompactLayout ? '' : 'ml-[4px]'} typography-h400 text-n-600` }, (0, HelperUtils_1.getObjectiveLocale)(label))));
};
exports.default = TopParent;
